import { A } from "@/components/standard/Html"
import DownloadAppleAppStore from "@/assets/logo/apple-app-store.svg"
import { View } from "react-native"

export const AppleStoreDownloadButton = ({
  onPress,
  width = 143,
  height = 48,
}: {
  onPress: () => void
  width?: number
  height?: number
}) => (
  <View className="flex flex-col items-center justify-center shrink-0">
    <A
      href="https://apps.apple.com/us/app/backflip-real-estate-investing/id1617572041"
      onPress={onPress}
    >
      <DownloadAppleAppStore cssInterop={false} width={width} height={height} />
    </A>
  </View>
)
